import React, {PureComponent} from 'react';
import VertForm from './forms/vertForm';
import PropTypes from "prop-types";
import TransferTable from './tables/transferTable';
import DemoModal from './modal/demoModal';
import TransferModal from './modal/transferModal';

class Demo extends PureComponent {
  constructor (props) {
    super();
    this.init();
    this.props = props;
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  }

  init () {
    this.title = 'Form示例';
    this.subTitle = '纵向示例表单';
  }

  render () {
    return <div>
      <div className={'isHot'}>当前Tab参数： 我觉得这个热更新很吊</div>
      <VertForm tableKey={'002'} layout={0}></VertForm>
      <DemoModal/>
      <TransferTable tableKey={'002'} addTab={this.props.addTab}></TransferTable>
      <TransferModal/>
    </div>;
  }
}

export default Demo;

Demo.propTypes = {
  addTab: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo/demo.js